import script from "./MetricPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./MetricPanel.vue?vue&type=script&setup=true&lang=ts"

import "./MetricPanel.vue?vue&type=style&index=0&id=4c6cae94&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.24_vue@3.5.24_typescript@4.5.5__webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c6cae94"]])

export default __exports__